import React from 'react';
import './food.scss';
import {Col, Container, Row} from 'react-bootstrap';

import FoodList from '../../data/food.json';

function Food() {
  return (
    <div id="food" className="our-food pt50">
      <Container>
      <Row>
          <Col sm={12} className="mb50">
            <div className="section-title">Our Kitchen</div>
            <h2>Try New Cuisine</h2>
            <div className="p-sides">
                <div className="subtitle">
                    <span className="d-none d-sm-block">
                      We don't have a restaurant, café or tavern. This is our private home, and from time to time we are happy to prepare traditional homemade meals for our guests upon request.
                      <br/><br/>
                      Every dish is prepared using fresh ingredients, family recipes and a personal touch. If you would like to enjoy lunch or dinner during your stay, simply let us know in advance and we'll do our best to prepare something special for you.
                    </span>
                </div>
            </div>
          </Col>

          <Col md={12} className='event-item'>
              <div className="grid">
                  <ul id="hexGrid">
                      {FoodList && FoodList.map((item) => {
                          return (
                              <li className="hex" key={item.id}>
                                  <div className="hexIn">
                                      <a className="hexLink">
                                          <div className='img'
                                               style={{backgroundImage: "url(" + item.image + ")"}}></div>
                          <h1 id="food-title">{item.title}</h1>
                          <p id="food-desc">{item.description}</p>
                        </a>
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </Col>
          <Col sm={12}>
              <p style={{textAlign: "center"}}><strong>*Homemade vegetarian and vegan meals are available upon request. Please let us know in advance.</strong></p>
          </Col>

          {/*<Col sm={12}>
            <Row className='food-line'>
                <Col sm={6}>
                    <h3>Uzbek Plov (Lamb and Rice Pilaf)</h3>
                    <p>Traditionally, Uzbek Plov is made with lamb meat. </p>
                    <p>Though served all over central Asia, plov is a national obsession in Uzbekistan, where people pride themselves on their skill in preparing the tasty dish.</p>
                    <p>* 15 euro per person / 5 euro for kids<br />
                       * Min. order: 5 persons <br />
                       * Free salad is included
                    </p>
                </Col>
                <Col sm={6}>
                    <img src={pilaf} alt="Uzbek Plov (Lamb and Rice Pilaf)" />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <h3>Fried fresh meat with potato</h3>
                    <p>It is one of the oldest recipes found in Central Asia. </p>
                    <p>Traditionally, the meat used is mutton (lamb). The most common additions beyond this are just potatoes, onions and possibly garlic. Thus, with a bit of chopping, this dish comes together in no time!</p>
                    <p>* 15 euro per person / 5 euro for kids<br />
                       * Salad: 5 euro <br /> 
                       * Min. order: 2 persons 
                    </p>
                </Col>
                <Col sm={6}>
                    <img src={fried_meat} alt="Fried meat with potato" />
                </Col>
            </Row>
          </Col>*/}
        </Row>
      </Container>
    </div>
  )
}

export default Food;
